// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeBadRecordRequestDto
 */
export interface IEmployeeBadRecordRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeBadRecordRequestDto
     */
    new_primary_employee_id?: number;
}

/**
 * Check if a given object implements the IEmployeeBadRecordRequestDto interface.
 */
export function instanceOfIEmployeeBadRecordRequestDto(value: object): value is IEmployeeBadRecordRequestDto {
    return true;
}

export function IEmployeeBadRecordRequestDtoFromJSON(json: any): IEmployeeBadRecordRequestDto {
    return IEmployeeBadRecordRequestDtoFromJSONTyped(json, false);
}

export function IEmployeeBadRecordRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeBadRecordRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'new_primary_employee_id': json['new_primary_employee_id'] == null ? undefined : json['new_primary_employee_id'],
    };
}

export function IEmployeeBadRecordRequestDtoToJSON(json: any): IEmployeeBadRecordRequestDto {
    return IEmployeeBadRecordRequestDtoToJSONTyped(json, false);
}

export function IEmployeeBadRecordRequestDtoToJSONTyped(value?: IEmployeeBadRecordRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'new_primary_employee_id': value['new_primary_employee_id'],
    };
}

